/** @prettier */
import React from "react";
import { Button, Modal } from "react-bootstrap";

type AssignSelfModalProps = {
    assignSelf: () => void;
    closeModal: () => void;
};
const AssignSelfModal = ({ closeModal, assignSelf }: AssignSelfModalProps) => {
    const submit = async () => {
        await assignSelf();
        closeModal();
    };
    return (
        <Modal show={true} onHide={closeModal}>
            <Modal.Header>
                <Modal.Title>Assign question</Modal.Title>
            </Modal.Header>
            <Modal.Body>Assign this question to yourself?</Modal.Body>
            <Modal.Footer>
                <Button bsStyle="link" onClick={closeModal}>
                    Cancel
                </Button>
                <Button bsStyle="primary" onClick={submit}>
                    Assign
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AssignSelfModal;
